import backgroundImage1 from 'images/career-mission-background.jpg';
import backgroundImage2 from 'images/background-harvest.jpg';

export const careerData = {
    title: (
        <>
            What makes us <br /> different
        </>
    ),
    background: backgroundImage1,
    cards: [
        {
            title: 'Open Communication',
            text: "Unlike many large well-known companies, we don't have big hierarchical differences, communication at all levels is quick and easy, and formal communication is frowned upon, which gives everyone almost endless opportunities for growth and development.",
        },
        {
            title: 'Opportunities for growth',
            text: 'Right from the start, you take responsibility, are held accountable and encouraged to deliver results. Your career depends primarily on your real individual contribution, not on "politically correct behavior" or your position.',
        },
        {
            title: 'Own point of view',
            text: 'We encourage a willingness to engage in reasoned debate and a strong character, personality and ability to defend your own point of view if necessary, if you are convinced that you are right.',
        },
    ],
};

export const aboutUsData = {
    title: <>Mission & values</>,
    background: backgroundImage2,
    cards: [
        { title: "We can't revert climate change, but we can influence its impact on harvest. " },
        { title: 'Ensuring safer harvests in an unsafer environment.' },
        { title: 'Striving to discover new solutions, meeting the challenges of farming in times of climate change.' },
    ],
};

export const homepageData = {
    title: (
        <>
            Ensuring safer <br />
            harvests in an unsafer environment
        </>
    ),
    cards: [
        {
            text: 'We at UniferX cannot revert climate change, but we can help to change its impact on agriculture, thereby ensuring a safer supply of crops and food - for today as well as tomorrow.',
        },
        {
            text: 'At UniferX, we strive to combine the qualities of a responsible, dynamic international company with originality and uniqueness with the benefits of a family business philosophy - a philosophy guided by European values and solutions made in Germany.',
        },
        {
            text: 'We offer intelligent solutions that enable plants to adapt to constantly changing climatic and environmental conditions. High-performance, environmentally friendly products and technologies for agriculture, inspired by nature and respecting nature.',
        },
    ],
    background: backgroundImage2,
};
